import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { NodeModel } from '../../../models/node-model';
import { IOrganizationNodeAM, OrganizationalUnitService } from './organizational-unit-service';

@autoinject
export class OrganizationalUnits {
	@bindable organizationId;
	@bindable fiscalYearId: string;
	@bindable searchTerm: string;
	@bindable includeIgnoredCostCenters: boolean = true;

	@bindable selectedUnit: IOrganizationNodeAM;
	preSelectedUnit: IOrganizationNodeAM;

	private nodesRepresentingFiscalYearId: string;

	constructor(private service: OrganizationalUnitService) {
	}

	@computedFrom('service.treeNodes')
	get organizationalUnits(): NodeModel[] {
		return this.service.treeNodes;
	}

	@computedFrom('service.refreshingNodes')
	get refreshingNodes(): boolean {
		// Set structure to preselected unit if it is not refreshing and there are units
		if (this.service.refreshingNodes == false && this.organizationalUnits.length > 0) {
			setTimeout(() => {
				this.preSelectedUnit = this.selectedUnit;
			}, 10);
		} else {
			this.preSelectedUnit = null;
		}

		return this.service.refreshingNodes;
	}

	attached() {
		this.refreshNodes();
	}

	fiscalYearIdChanged(newValue: string, oldValue: string) {
		if (newValue !== oldValue) {
			this.refreshNodes();
		}
	}

	refreshNodes(): void {

		if (this.fiscalYearId) {
			if (this.nodesRepresentingFiscalYearId == this.fiscalYearId) { return; }
			this.service.refreshOrganizationalUnitsForFiscalYear(this.fiscalYearId, this.includeIgnoredCostCenters);
			this.nodesRepresentingFiscalYearId = this.fiscalYearId;
		}
		else {
			this.service.refreshOrganizationalUnits(this.organizationId, this.includeIgnoredCostCenters);
		}
	}
}
